<mat-form-field appearance="outline">
  <mat-select [placeholder]="getStatusRoute(this.element?.status)| translate" [style.text-align]="'center'"
    style="--statusSelected: {{getColorStatusSelected()}}" (selectionChange)="putAlertLevel(element.id, $event)">
    <mat-option *ngFor="let niveau of level" [value]="niveau.value" [style.text-align]="'center'">
      <fa-icon [icon]="faBouboule"
        [ngClass]="{green: niveau.value ==='Low', orange: niveau.value ==='Medium',red: niveau.value ==='High' }">
      </fa-icon>
      {{niveau.viewValue}}
    </mat-option>
  </mat-select>
</mat-form-field>